<template>
  <teleport to="body">
    <div
      class="map-modal fixed inset-0 z-[1200]"
      :class="{
        'map-modal--single': isSingleDoctor,
        'map-modal--with-list': showList,
      }"
      id="mapModal"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="map-modal__backdrop absolute inset-0 bg-black/65"
        @click="closeMapModal"
      />

      <div
        class="map-modal__inner relative z-[1] h-full w-full overflow-y-auto md:overflow-y-visible md:flex md:items-center md:justify-center px-[1.6rem] py-[4.8rem] sm:px-[1.2rem]"
      >
        <div class="map-modal__body relative max-w-[120rem] w-full mx-auto px-[1.8rem] py-[4.8rem] sm:px-[1.2rem] md:py-0 md:px-0">
          <div class="md:container mx-auto">
            <div class="map_popup_background">
              <div class="flex flex-wrap map_popup_row">

                <div class="map-modal__frame bg-white-50 rounded-[2.4rem] p-4 sm:p-5 md:p-6 border border-white md:max-w-none max-w-full w-full">
                  <div class="map-modal__stack md:flex gap-4 md:pb-4">
                    <div
                      v-if="showList"
                      class="map-modal__list-panel lg:w-1/2 bg-white backdrop-blur-[2px] rounded-t-[2.9rem] rounded-b-none md:rounded-[2.9rem] px-4 sm:px-5 py-5 w-full sm:pb-4"
                    >
                      <div class="map-modal__list">
                        <div
                          v-if="!hasDoctors"
                          class="map-modal__list-card px-[3.2rem] py-[2.4rem] sm:px-[1.6rem] sm:pt-[1.2rem] sm:pb-[1.2rem] text-center text-gray-500 text-[1.2rem]"
                        >
                          {{ $t('No results found') }}
                        </div>
                        <div
                          v-else
                          v-for="(doctor, index) in doctors"
                          :key="index"
                          :id="'doctor-' + index"
                          class="map-modal__list-card"
                        >
                          <div class="map-modal__list-card-body">
                            <DoctorComponent
                              :doctor="doctor"
                              :showServiceTime="false"
                              :showPersonalizedService="false"
                              :showMapButton="true"
                              :showProfileButton="true"
                              :show-doctor-reviews="false"
                              :active-booking-key="resolveSelectedBookingKey(doctor)"
                              class="map-modal__doctor px-4 sm:px-5 py-5 sm:pb-4 rounded-3xl sm:rounded-t-3xl open_map_area"
                              @view-map="onDoctorViewMap(doctor)"
                              @select-booking-option="handleBookingOptionSelection(doctor, $event)"
                            />
                            <DoctorSchedule
                              :key="getDoctorScheduleKey(doctor, index)"
                              :doctor="doctor"
                              :selected-booking-key="resolveSelectedBookingKey(doctor)"
                            :dates-loading="datesLoading"
                            :schedule-version="doctor?.scheduleVersion || 0"
                            :base-date="doctor?.baseDateIso || null"
                            :isPopup="true"
                            class="map-modal__schedule w-full px-4 sm:px-5 py-5 sm:pt-0 rounded-3xl md:rounded-3xl open_map_area mt-5 sm:mt-0 sm:rounded-b-3xl"
                            @booking-option-change="(...args) => handleScheduleBookingOption(doctor, ...args)"
                            @request-more-dates="handleRequestMoreDates(doctor, $event)"
                            @request-calendar="handleRequestCalendar(doctor, $event)"
                          />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div :class="mapPanelClass">
                      <div class="open_map_content map_main_wrap w-full map-modal__map">
                        <div class="map-modal__map-card relative w-full rounded-[2.4rem] overflow-hidden">
                          <GoogleMaps
                            :doctors="doctors"
                            class="map-modal__map-frame"
                            ref="map"
                            @map-idle="handleMapIdle"
                          />
                          <MapSearchButton
                            v-if="allowMapSearch && mapDirty"
                            class="map-modal__search-button absolute top-4 left-1/2 -translate-x-1/2 z-[2]"
                            :loading="searchLoading"
                            :disabled="searchLoading"
                            @click.prevent="requestSearchArea"
                          />
                          <div class="map-modal__map-close">
                            <CloseButton @click="closeMapModal" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import mapModalConfig from './mapModal.logic';

export default mapModalConfig;
</script>


<style scoped>
#mapModal{
  z-index: 1200;
}

.map-modal__backdrop {
  background: rgba(0, 0, 0, 0.65);
}

.sticky-lg-top{
  position: sticky;
  top: 0;
  z-index: 1020;
}

.map_popup_row {
  --bs-gutter-x: 4.8rem;
}

.open_map_area {
  background: #fff;
}

.open_map_content {
  @apply border p-[1.6rem] rounded-[3.2rem] border-solid border-white;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 24px 48px rgba(14, 32, 56, 0.12);
}

.open_map_content.sticky-lg-top {
  @apply top-[4.8rem];
}

.map-modal__map {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.map-modal__list {
  background: #f6f7f9;
  border-radius: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  box-shadow: 0 24px 48px rgba(14, 32, 56, 0.12);
}

.map-modal__list-card {
  @apply border p-[1.6rem] rounded-[3.2rem] border-solid border-white;
  background: rgba(255, 255, 255, 0.92);
  box-shadow:
    0 12px 32px rgba(14, 32, 56, 0.12),
    0 0 16px rgba(14, 32, 56, 0.08);
}

.map-modal__list-card-body {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.map-modal__map.map_main_wrap {
  border: none;
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.map-modal__map-card {
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  height: clamp(32rem, calc(100vh - 16rem), 64rem);
  background: #f6f7f9;
}

.map-modal__map-frame {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  display: block;
}

.map-modal__map-close {
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
}

@media (min-width: 768px) {
  .map-modal__list {
    max-height: calc(100vh - 9.6rem);
    overflow-y: auto;
    scrollbar-width: none;
  }
  .map-modal__list::-webkit-scrollbar {
    display: none;
  }

  .map-modal__map {
    min-height: calc(100vh - 9.6rem);
    justify-content: center;
  }

  .map-modal__map-card {
    max-width: 100%;
    height: calc(100vh - 10rem);
  }
}

@media (max-width: 767px) {
  .map-modal__backdrop {
    background: rgba(149, 149, 149, 0.5);
    backdrop-filter: blur(12px);
  }

  .map-modal__inner {
    padding: 1.6rem 0.8rem;
  }

  .map-modal__body {
    padding: 0;
  }

  .map_popup_row {
    position: relative;
    flex-direction: column;
  }

  .map-modal--with-list .map-modal__stack {
    --map-list-height: clamp(24rem, 46vh, 36rem);
    --map-list-offset: 2.2rem;
  }

  .map-modal__frame {
    padding: 1rem;
    border-radius: 2.4rem;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0 4px 34px rgba(193, 193, 193, 0.25);
  }

  .map-modal__stack {
    position: relative;
    min-height: calc(100vh - 8.8rem);
    height: calc(100vh - 8.8rem);
  }

  .map-modal__map-panel {
    height: 100%;
    padding: 1rem;
    border-radius: 2.4rem;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 4px 34px rgba(193, 193, 193, 0.25);
    z-index: 1;
    min-height: calc(100vh - 8.8rem);
  }

  .map-modal__list-panel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1.2rem;
    z-index: 2;
    padding: 0 0.8rem;
    background: transparent;
    border-radius: 0;
    backdrop-filter: none;
    height: var(--map-list-height, clamp(24rem, 46vh, 36rem));
  }

  .map-modal__list {
    flex-direction: row;
    max-height: none;
    overflow-x: auto;
    overflow-y: hidden;
    padding-right: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    gap: 1.6rem;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    align-items: stretch;
    height: 100%;
  }

  .map-modal__list::-webkit-scrollbar {
    display: none;
  }

  .map-modal__map {
    min-height: auto;
    height: 100%;
  }

  .map-modal--with-list .map-modal__map {
    height: calc(100% - var(--map-list-height) - var(--map-list-offset));
  }

  .map-modal__map-card {
    max-width: none;
    height: 100%;
    border-radius: 2.4rem;
  }

  .map-modal__map-frame {
    height: 100%;
  }

  .map-modal__search-button {
    top: 1.2rem;
  }

  .map-modal__list-card {
    border-radius: 1.8rem;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 4px 34px rgba(193, 193, 193, 0.25);
    flex: 0 0 auto;
    width: min(38rem, 94vw);
    scroll-snap-align: center;
    height: 100%;
    overflow: hidden;
    display: flex;
    scrollbar-width: none;
  }

  .map-modal__list-card::-webkit-scrollbar {
    display: none;
  }

  .map-modal__list-card-body {
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  .map-modal__list-card-body::-webkit-scrollbar {
    display: none;
  }

  .map-modal__schedule {
    height: auto;
  }

  .map-modal--single .map-modal__list-card {
    width: 100%;
  }

  .map-modal--single .map-modal__list-panel {
    padding: 0;
  }

  .map-modal--single .map-modal__list {
    overflow-x: hidden;
  }

}

</style>
